export default "__VITE_ASSET__DgV29yww__"